import { Icon, Link, Stack } from '@ace-clublabs/shared-component-library';

export interface MakeChangeLinkProps {
  onOpenModal: () => void;
}

export const MakeChangeLink = (props: MakeChangeLinkProps) => {
  return (
    <Stack direction="row" width="100%" gap="0.5rem" marginBottom="1.5rem">
      <Icon
        iconName="circle-question-regular"
        sx={{ color: '#0156A3', fontSize: '1.5rem' }}
        className="make-change-icon"
      />
      <Link
        className="make-change-link"
        onClick={() => {
          props.onOpenModal();
        }}
        sx={{ alignSelf: 'center' }}
      >
        Need to make changes, downgrade, or cancel?
      </Link>
    </Stack>
  );
};
